import {
  Button,
  Col,
  Collapse,
  Image,
  Row,
  Typography,
  List,
  notification,
  Tabs,
} from "antd";
import { Content } from "antd/lib/layout/layout";
import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link, useHistory, useLocation } from "react-router-dom";
import { AddToOrder, DownloadAssets, StockLevel } from "../../assets/images";
import AudioPlayers from "../../components/audioPlayer";
import QuantityCounter from "../../components/quantityCounter";
import Releases from "../../components/releases";
import {
  addToCartOrder,
  CartDetailShow,
  CartInfo,
  DeleteCart,
  downloadReleaseDescription,
  getproduct,
  getProductTracks,
  getRelproducts,
  getSecondryImages,
} from "../../store/products/productsAsyncActions";
import { useDispatch, useSelector } from "react-redux";
import { CartOrders, ProductsMdl } from "../../Modal/Products";
import { setLoading } from "../../store/common/commonActions";
import {
  previousLocation,
  storeLabelsValue,
  storeProduct,
  storeProductReleaseEnumValue,
  storeredirectPath,
  storeReleasesEnumsValue,
  storeRelProducts,
} from "../../store/products/productsActions";
import Loadingtext from "../../components/loading";
import NoRecordFound from "../../components/NoRecordFound";
import { DownloadAsset, imageUrl, musicUrl } from "../../utils/functions";
import Localize, { isCart } from "../../utils/string";
import moment from "moment";
import { AlignmentType, Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import { convert } from "html-to-text";

const ReleasesDesc = (props: any) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { TabPane } = Tabs;
  const { Panel } = Collapse;
  const proId = props?.computedMatch?.params?.catNo;
  const [count, setCount] = useState(0);
  const [secondaryImages, setSecondaryImages] = useState([] as any);
  const [productTracks, setProductTracks] = useState([] as any);
  const [allIndex, setAllIndex] = useState([]);
  const [secondaryImageLoading, setsecondaryImageLoading] = useState(true);
  const [relProductsLoading, setRelProductsLoading] = useState(true);
  const [buttonText, setButtonText] = useState<string>('ADD TO ORDER');


  const productReleseasValue: any = useSelector(
    (state: any) => state.products.productReleseasValue
  );
  const Loading = useSelector((state: any) => state.common.loading);
  const isLogin = useSelector((state: any) => state.user.isLogin);
  const loginResp = useSelector((state: any) => state.user.userSession);
  const [productReleaseEnumValue, setProductReleaseEnumValue] = useState(1);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const location = useLocation();
  const ProductData: ProductsMdl = useSelector(
    (state: any) => state.products.product
  );
  
  const AddedCartProduct: any = useSelector(
    (state: any) => state.products.AddedCartProduct
  );
  useEffect(() => {
    if (AddedCartProduct && AddedCartProduct.cartItems && AddedCartProduct.cartItems.length > 0) {
      const obj = AddedCartProduct.cartItems.find((option: any) => option.products.catNo === proId
      )
      if (obj && obj?.quantity > 0) {
        setButtonText('UPDATE ORDER');
      }else{
        setButtonText('ADD TO ORDER');
      }
      setCount(obj?.quantity ?? 0);
    } else {
      setCount(0);
    }
  }, [location, AddedCartProduct]);

  //secondary_labelname
  let RelProductsData: ProductsMdl[] = useSelector(
    (state: any) => state.products.Relproducts
  );

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  // RelProductsData = RelProductsData.filter((item) => item?.catNo != proId);
  // console.log(RelProductsData);

  function weekNumber(date: any) {
    let current: any = new Date();
    let productDate = new Date(date).getTime();
    let currentDate: any = new Date();
    let TWeek: any = current.getDate() - 10 * 7;
    currentDate.setDate(TWeek);
    if (productDate < new Date(currentDate).getTime()) {
      // dispatch(storeProductReleaseEnumValue(null));
    } else {
      setProductReleaseEnumValue(1);
      dispatch(storeProductReleaseEnumValue(1));
    }
  }
  useEffect(() => {
    if (ProductData?.startDateSelectedWeek) {
      weekNumber(ProductData?.startDateSelectedWeek);
    }
    // var week = Math.ceil(( new Date().getDay() + 1 + days) / 7);
  }, [ProductData]);

  const [customerId, setCustomerId] = useState(0);
  const [specList, setSpecList] = useState([] as any);
  const [genreList, setGenre] = useState([] as any);
  // const navigate = useNavigate();
  const _enum: any = {
    1: "New Release",
    2: "FORTHCOMING",
    3: "REPRESSES",
    4: "BEST SELLER",
    5: "RSD RELEASE",
  };

  useEffect(() => {
    scrollToTop();
    setRelProductsLoading(true);
    setsecondaryImageLoading(true);
    setSecondaryImages([]);
    getProductById();
  }, [proId, dispatch]);
  const getSpecList = (props: any) => {
    const { formatFeature, extrasIncl, weight, discColour } = props;
    const list = [formatFeature, extrasIncl, weight, discColour];
    let newArray: any = [];
    const capitalize = (s: any) => {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    };
    // if (format) {
    //   const spec = capitalize(format);
    //   newArray.push(spec.trim());
    // }
    if (formatFeature) {
      const spec = capitalize(formatFeature);
      newArray?.push(spec?.trim());
    }
    if (extrasIncl) {
      const spec = capitalize(extrasIncl);
      newArray.push(spec?.trim());
    }
    if (weight) {
      const spec = capitalize(weight);
      newArray.push(spec?.trim());
    }
    // if (discColour) {
    //   const spec = capitalize(discColour);
    //   newArray.push(spec?.trim());
    // }
    //\xa0 for space
    const lists: any = newArray?.join(`,\xa0`);
    setSpecList(lists);
  };

  const getGenericList = (props: any) => {
    const { genreMappings } = props;
    const newArray = props?.genreMappings?.map((elem: any) =>
      elem?.genres?.name.trim()
    );

    const lists: any = newArray?.join(`,\xa0`);
    if (lists) {
      setGenre([lists]);
    }
    // setGenre([lists]);
  };

  const getProductById = async () => {
    if (proId) {
      dispatch(setLoading(true));
      const CID = loginResp ? loginResp?.userId : 0;
      const Qparams = "?catNo=" + proId + `&CustomerId=` + CID;
      const response1: any = await dispatch(getproduct(Qparams));
      if (response1) {
        getSpecList(response1);
        getGenericList(response1);
        // const CID = loginResp ? loginResp?.userId : 0; + `&CustomerId=` + CID
        const Qparams1 = "?id=" + response1?.id;
        const response: any = await dispatch(getSecondryImages(Qparams1));
        const responseOfTracks: any = await dispatch(
          getProductTracks(Qparams1)
        );
        setProductTracks(responseOfTracks?.value);
        if (response?.length > 0) {
          let cpy = [...response];
          cpy = cpy.map((item) => item + `?v=${Date.now()}`)
          cpy.unshift(
            `${process.env.REACT_APP_IMAGES_URL}products/${response1?.productType?.name}/${response1?.catNo}/promos/images/rel.jpg?v=${Date.now()}`
          );
          setSecondaryImages(cpy);
        }
        if (response) {
          setsecondaryImageLoading(false);
        }
      } else {
        setsecondaryImageLoading(false);
        setRelProductsLoading(false);
        dispatch(setLoading(false));
      }
    }
  };

  const initialFunction: any = async () => {
    const CID = loginResp ? loginResp?.userId : 0;
    const pId = proId ? proId : 0;
    setCustomerId(loginResp?.userId);
    const labelValue = ProductData?.secondary_labelname
      ? ProductData?.secondary_labelname
      : ProductData?.labels?.name;
    const value = labelValue?.length && labelValue?.replace("&", "%26");
    const QparamsRel =
      `?id=${ProductData?.id}&startIndex=1&pageSize=8&searchBy=` +
      `${value}&sortBy=${"DESC"}&CustomerId=` +
      CID;
    // proId ?`&catNo=${proId}`:""
    const res: any = await dispatch(getRelproducts(QparamsRel));
    if (res) {
      setRelProductsLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(storeRelProducts([]));
      dispatch(storeProduct([]));
    };
  }, []);
  useEffect(() => {
    if (ProductData?.label_id) {
      initialFunction();
    }
  }, [ProductData]);

  const plusHandler = () => {
    return setCount((count) => count + 1);
  };

  const minusHandler = () => {
    if (count === 0 || count < 0) {
      return false;
    } else {
      return setCount((count) => count - 1);
    }
  };

  const setHandleClick = async () => {
    if (loginResp) {
      const params: CartOrders = {
        quantity: count,
        productId: ProductData?.id,
        customerId: loginResp?.userId,
      };
      const index = AddedCartProduct?.cartItems?.findIndex((option: any) => option?.productId === ProductData?.id) ?? -1;
      if (index === -1) {
        if(params?.quantity  === 0) return;
        const response: any = await dispatch(addToCartOrder(params));
        if (response) {
          const fetchData = async () => {
            const Qparams: any = `?customerId=${loginResp?.userId}`;
            const response: any = await dispatch(CartDetailShow(Qparams));

            const openNotificationWithIcon = () => {
              const key = `open${Date.now()}`; // Generate a unique key for the notification

              notification["success"]({
                message: "Cart Updated",
                description: "Product added to your cart.",
                placement: "bottomRight",
                duration: 0, // This will keep the notification open indefinitely
                key, // Assign the key to the notification
              });

              // Example: Close the notification after 3 seconds (you can adjust this as needed)
              setTimeout(() => {
                notification.close(key);
              }, 3000); // Close after 3 seconds
            };

            openNotificationWithIcon();
            // }
          };
          fetchData();
        }
      } else {
        dispatch(setLoading(true));
        const params1 = {
          id: AddedCartProduct?.cartItems[index]?.id,
          quantity: count,
        };

        if (params1?.quantity === 0) {
          deleteProductCart(params1?.id);
          setButtonText('ADD TO ORDER');
        } else {
          const response: any = await dispatch(CartInfo(params1));
          if (response) {
            const Qparams: any = `?customerId=${loginResp?.userId}`;

            // Fetch updated cart details
            const response1: any = await dispatch(CartDetailShow(Qparams));
            if (response1) {

              dispatch(setLoading(false));
              const openNotificationWithIcon = (props: any) => {
                notification["success"]({
                  message: "Cart Updated",
                  description: "Selected quantity has been updated.",
                  placement: "bottomRight",
                });
              };

              openNotificationWithIcon("success");
            }
          }
        }
      }
    } else {
      if (!customerId || !loginResp) {
        const url = location.pathname.substring(0, 8);
        dispatch(previousLocation(url));
        history.push("/login");
      }
    }
  };

  async function deleteProductCart(id: any) {
    const query: any = `?cartItemId=${id}`;
    const response: any = await dispatch(DeleteCart(query));
    if (response) {
      const Qparams: any = `?customerId=${loginResp?.userId}`;
      const response1: any = await dispatch(CartDetailShow(Qparams));
      notification["success"]({
        message: " Product removed from your cart.",
        description: "",
        placement: "bottomRight",
      });
    }
  }


  // Function to parse HTML content and convert it to formatted text
  const parseHTMLToTextWithFormatting = (htmlContent: string) => {
    const parsedText: string[] = [];

    // Use a simple regex to replace <b> with **bold** and <br> with line breaks
    const regex = /(<b>|<\/b>|<br\s*\/?>)/g;
    const parts = htmlContent.split(regex);

    let inBold = false;
    parts.forEach(part => {
      if (part === '<b>') {
        inBold = true;
      } else if (part === '</b>') {
        inBold = false;
      } else if (part === '<br />' || part === '<br>') {
        parsedText.push("\n");  // Add line break for <br>
      } else {
        if (inBold) {
          parsedText.push(`**${part}**`);  // Bold the text inside <b> tags
        } else {
          parsedText.push(part);
        }
      }
    });

    // Join all the parts and return the formatted text
    return parsedText.join('');
  };

  const handleClick = () => {
    if (loginResp) {
      // const artistName = `${ProductData?.artists?.name}${
      //   ProductData?.artist2 ? ` / ${ProductData?.artist2?.name}` : ""
      // }${
      //   ProductData?.artist3 ? ` / ${ProductData?.artist3?.name}` : ""
      // }${
      //   ProductData?.artist4 ? ` / ${ProductData?.artist4?.name}` : ""
      // }${
      //   featuringName !== "" ? ` Featuring ${featuringName}` : ""
      // }`;
      // // Tracklist details
      // const newProductTracks: string[] = [];
      // productTracks.map((element: any, index: number) => {
      //   element?.tracks?.map((elem: any, index1: number) => {
      //     const text = `${alphabetPosition(index + 1)}${index1 + 1} - ${
      //       elem?.webTitle || elem?.title
      //     }`;
      //     newProductTracks.push(text);
      //   });
      // });

      // // Create a new document
      // const doc = new Document({
      //   sections: [
      //     {
      //       properties: {},
      //       children: [
      //         // Artist(s) label with name (only add if ProductData.artists and ProductData.artists.name exist)
      //         ...(artistName ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Artist(s): `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: artistName,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),
      //         ] : []),

      //         // Release Title label with title (only add if ProductData.title exists)
      //         ...(ProductData?.title ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Release Title: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: ProductData.title,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),
      //         ] : []),

      //         // Label label with label name (only add if ProductData.labels?.name exists)
      //         ...(ProductData?.labels?.name ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Label: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: ProductData.labels.name,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),
      //         ] : []),

      //         // Cat No label with catNo (only add if ProductData.catNo exists)
      //         ...(ProductData?.catNo ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Cat No: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: ProductData.catNo,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),
      //         ] : []),

      //         // Barcode label with barcode number (only add if ProductData.barcode exists)
      //         ...(ProductData?.barcode ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Barcode: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: ProductData.barcode,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),
      //         ] : []),

      //         // Format label with format (only add if ProductData.format exists)
      //         ...(ProductData?.format ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Format: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: ProductData.format,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),
      //         ] : []),

      //         // Genre label with genre name (only add if ProductData.genre exists)
      //         ...(genreList ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Genre: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: genreList.join(','),
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),
      //         ] : []),

      //         // Spec label with specification (only add if ProductData.spec exists)
      //         ...(specList ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Spec: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: specList,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),
      //         ] : []),

      //         // Disc Colour label with disc color (only add if ProductData.discColor exists)
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Disc Colour: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: ProductData?.discColour || "Black",
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),

      //         // Unit Price label with unit price (only add if ProductData.unitPrice exists)
      //         ...(ProductData?.sellPrice ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Unit Price: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //               new TextRun({
      //                 text: formatCurrency(ProductData?.sellPrice),
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 200 },
      //           }),
      //         ] : []),

      //         ...(ProductData?.hype ? [
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: `Description: `,
      //                 bold: true,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             spacing: { after: 100 },
      //           }),
      //         ] : []),

      //         // Description Section (only add if ProductData?.artists?.description exists)
      //         ...(ProductData?.hype ? [
      //           ...convertHtmlToDocx(ProductData?.hype), // Convert HTML to docx components
      //         ] : []),

      //         // Tracklist Section
      //         new Paragraph({
      //           children: [
      //             new TextRun({
      //               text: `Tracklist:`,
      //               bold: true,
      //               font: "Calibri",
      //               size: 22,
      //             }),
      //           ],
      //           spacing: { after: 200,before:200 },
      //         }),

      //         // Tracklist items (only add if `newProductTracks` is not empty or undefined)
      //         ...(newProductTracks && newProductTracks.length > 0 ? newProductTracks.map((track, idx) =>
      //           new Paragraph({
      //             children: [
      //               new TextRun({
      //                 text: track,
      //                 font: "Calibri",
      //                 size: 22,
      //               }),
      //             ],
      //             bullet: {
      //               level: 0, // This will create an unordered list (bullet point)
      //             },
      //             spacing: { before: 100, after: 100 },
      //           })
      //         ) : []),
      //       ], // No need for filter(Boolean) here anymore
      //     },
      //   ],
      // });
      // // Convert the document to a Blob (for downloading)
      // Packer.toBlob(doc).then((blob) => {
      //   // Trigger download using FileSaver.js
      //   saveAs(blob, `Release Full Details - ${ProductData.catNo}.docx`);
      // });
      // window.open(
      //   DownloadAsset(ProductData?.productType?.name, ProductData?.catNo),
      //   "_blank"
      // );
      const query = `?catNo=${ProductData?.catNo}&customerId=${loginResp?.userId}`;
      dispatch(downloadReleaseDescription(query, setIsDownload));
    } else {
      const url = location.pathname.substring(0, 8);
      dispatch(previousLocation(url));
      history.push("/login");
    }
  };
  const handleClick1 = async (selectedOption: any) => {
    // dispatch(storeReleasesEnumsValue(selectedOption));
    // dispatch(storeredirectPath(true));
    history.push(`/releases?productReleaseEnumValue=${selectedOption}`);
  };
  const handleSaveLabelName = (selectedLabelName: any) => {
    const encoded: any = encodeURI(selectedLabelName);
    dispatch(storeLabelsValue(encoded));
    // dispatch(storeReleasesEnumsValue(selectedLabelName));
    // history.push(`/releases?label=${ProductData?.label_id}`)
    history.push(`/releases?labelName=${selectedLabelName}`);

    // ?labelId=9313
  };
  const formatCurrency = (amountString: string, currencySymbol = "£") => {
    const amount = parseFloat(amountString);
    if (isNaN(amount)) {
      return "Invalid amount";
    }
    // Format the number without the currency symbol
    const formattedAmount = new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
    // Manually prepend the currency symbol
    return `${currencySymbol}${formattedAmount}`;
  };

  function callback(key: any) { }

  function alphabetPosition(num: any) {
    let s = "",
      t;

    while (num > 0) {
      t = (num - 1) % 26;
      s = String.fromCharCode(65 + t) + s;
      num = ((num - t) / 26) | 0;
    }
    return s || undefined;
  }
  const [currentSlide, setCurrentSlide] = useState(0);
  const scrollToTop = () => {
    const top = document.getElementById("top") as HTMLElement;
    top.scrollIntoView();
  };
  const handleSlideChange = (index: number) => {
    setCurrentSlide(index);
  };

  const featuringName = `${ProductData.featuredArtist1_id != null ? ProductData.featuredArtist1_id : ""
    }${ProductData.featuredArtist2_id != null
      ? ` / ${ProductData.featuredArtist2_id}`
      : ""
    }${ProductData.featuredArtist3_id != null
      ? ` / ${ProductData.featuredArtist3_id}`
      : ""
    }${ProductData.featuredArtist4_id != null
      ? ` / ${ProductData.featuredArtist4_id}`
      : ""
    }`;

  // Convert HTML to docx components
  const htmlToDocx = (htmlContent: any) => {
    const docComponents: any[] = [];

    // Convert HTML to plain text with formatting
    const textContent = convert(htmlContent, {
      wordwrap: false,

    });

    // Split the text content into paragraphs
    const paragraphs = textContent.split('\n');

    paragraphs.forEach((paragraph: string) => {
      const textRuns: TextRun[] = []; // Explicitly define the type as TextRun[]
      const parts = paragraph.split(/(\*\*.*?\*\*|\*.*?\*|__.*?__)/g); // Split by bold, italic, and underline markers

      parts.forEach(part => {
        if (part.startsWith('**') && part.endsWith('**')) {
          textRuns.push(new TextRun({ text: part.slice(2, -2), bold: true }));
        } else if (part.startsWith('*') && part.endsWith('*')) {
          textRuns.push(new TextRun({ text: part.slice(1, -1), italics: true }));
        } else if (part.startsWith('__') && part.endsWith('__')) {
          textRuns.push(new TextRun({ text: part.slice(2, -2), underline: { type: 'single' } }));
        } else if (part.trim() === '') {
          // Handle empty parts (e.g., from line breaks)
          textRuns.push(new TextRun({ text: '\n' })); // Add a line break
        } else {
          textRuns.push(new TextRun({ text: part }));
        }
      });

      // Create a new paragraph for each line
      docComponents.push(new Paragraph({ children: textRuns }));
    });

    return docComponents;
  };

  // Function to handle lists
  const handleList = (htmlContent: string) => {
    const docComponents: any[] = [];
    const listItems = htmlContent.split(/<\/li>/g).filter(item => item.trim() !== '');

    listItems.forEach(item => {
      const text = item.replace(/<li>|<\/ul>|<\/ol>|<ul>|<ol>/g, '').trim();
      if (text) {
        docComponents.push(new Paragraph({
          children: [new TextRun({ text })], // Keep bullet formatting out of TextRun
          bullet: { level: 0 }, // Apply bullet formatting here in the Paragraph
        }));
      }
    });

    return docComponents;
  };

  // Function to handle images
  const handleImages = (htmlContent: string) => {
    const docComponents: any[] = [];
    const imgRegex = /<img[^>]+src="([^">]+)"[^>]*>/g;
    let match;

    while ((match = imgRegex.exec(htmlContent)) !== null) {
      const imgSrc = match[1];
      docComponents.push(new Paragraph({
        children: [new TextRun({ text: `Image: ${imgSrc}` })], // Placeholder for image
      }));
    }

    return docComponents;
  };

  // Main function to convert HTML to docx components
  const convertHtmlToDocx = (htmlContent: any) => {
    const docComponents = htmlToDocx(htmlContent);
    // const listComponents = handleList(htmlContent);
    // const imageComponents = handleImages(htmlContent);

    return [...docComponents];
  };

  return (
    <div className="releases-desc" id="top">
      {Loading || secondaryImageLoading || relProductsLoading ? (
        <Loadingtext />
      ) : (
        <>
          <div className="container">
            <Row className="">
              <Col sm={24} xl={12}>
                <div className="desktop-left-desc left-desc">
                  <div className="carousel">
                    <Carousel
                      className="releases-desc-slider"
                      onChange={handleSlideChange}
                      selectedItem={currentSlide}
                      showThumbs={false}
                      showIndicators={false}
                      centerMode={isMobile}
                      showArrows={false}
                      swipeable={true}
                    >
                      {/* infinite: false,
                      speed: 500,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: true,
                      beforeChange: this.beforeChange */}
                      {secondaryImages.length > 0 ? (
                        secondaryImages?.map((element: any, index: number) => {
                          return (
                            <div className="carousel-slide">
                              <Image
                                preview={false}
                                onError={(e: any) =>
                                  (e.target.src = "/default_image.png")
                                }
                                src={element.replace(
                                  "http://www.primedirectdist",
                                  "https://media.primedirectdist"
                                )}
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div className="carousel-slide">
                          <Image
                            preview={false}
                            src={`${process.env.REACT_APP_IMAGES_URL}products/${ProductData?.productType?.name}/${ProductData?.catNo}/promos/images/rel.jpg?v=${Date.now()}`}
                            onError={(e: any) =>
                              (e.target.src = "/default_image.png")
                            }
                          />
                        </div>
                      )}
                    </Carousel>
                    <div className="thumbnails">
                      {secondaryImages.length > 0 ? (
                        secondaryImages?.map((element: any, ind: number) => {
                          return (
                            <div
                              className={`thumbnail-image ${ind === currentSlide ? "active-slide" : ""
                                }`}
                              onClick={() => handleSlideChange(ind)}
                            >
                              <Image
                                preview={false}
                                onError={(e: any) => {
                                  setSecondaryImages((prev: string[]) => {
                                    return prev.filter(
                                      (img) =>
                                        img.replace(
                                          "http://www.primedirectdist",
                                          "https://media.primedirectdist"
                                        ) !== e.target.src
                                    );
                                  });
                                }}
                                src={element.replace(
                                  "http://www.primedirectdist",
                                  "https://media.primedirectdist"
                                )}
                              />
                            </div>
                          );
                        })
                      ) : (
                        <div
                          className={`thumbnail-image ${0 === currentSlide ? "active-slide" : ""
                            }`}
                          onClick={() => handleSlideChange(0)}
                        >
                          <Image
                            preview={false}
                            src={`${process.env.REACT_APP_IMAGES_URL}products/${ProductData?.productType?.name}/${ProductData?.catNo}/promos/images/rel.jpg?v=${Date.now()}`}
                            onError={(e: any) =>
                              (e.target.src = "/default_image.png")
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  {productTracks?.length > 0 && (
                    <>
                      <Typography.Text className="tract-text">
                        Tracklist
                      </Typography.Text>
                      <Tabs defaultActiveKey={"0"} onChange={callback}>
                        {productTracks?.map((element: any, index: any) => {
                          return (
                            <TabPane tab={element?.plabel} key={index}>
                              {element?.tracks?.map(
                                (elem: any, index1: any) => {
                                  return (
                                    <>
                                      <div className="track-list">
                                        <AudioPlayers
                                          track={musicUrl(
                                            elem?.productType?.name,
                                            elem?.catNo,
                                            elem?.soundClipFile
                                          )}
                                          index={index1}
                                          allIndex={allIndex}
                                          setAllIndex={setAllIndex}
                                        />
                                        <div className="audio-text">
                                          {alphabetPosition(index + 1)}
                                          {index1 + 1} -{" "}
                                          {elem?.webTitle || elem?.title}
                                          <br />
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              )}
                            </TabPane>
                          );
                        })}
                      </Tabs>
                    </>
                  )}
                </div>
              </Col>
              <Col sm={24} xl={12}>
                <div className="right-desc">
                  <div className="main-btn">
                    {/* isForthcoming
                    isRepresses
                    isRsdSpecial */}
                    {ProductData?.isForthcoming ? (
                      <Button
                        className="rounded-btn"
                        shape="circle"
                        onClick={() => handleClick1(2)}
                      >
                        {_enum[2]}
                        {/* JUST_IN */}
                      </Button>
                    ) : ProductData?.isForthcoming &&
                      ProductData?.isRepresses ? (
                      <Button
                        className="rounded-btn"
                        shape="circle"
                        onClick={() => handleClick1(2)}
                      >
                        {_enum[2]}
                        {/* JUST_IN */}
                      </Button>
                    ) : ProductData?.isRepresses ? (
                      <Button
                        className="rounded-btn"
                        shape="circle"
                        onClick={() => handleClick1(3)}
                      >
                        {_enum[3]}
                        {/* JUST_IN */}
                      </Button>
                    ) : ProductData?.isRsdSpecial ? (
                      <Button
                        className="rounded-btn"
                        shape="circle"
                        onClick={() => handleClick1(5)}
                      >
                        {_enum[5]}
                        {/* JUST_IN */}
                      </Button>
                    ) : productReleseasValue ? (
                      <Button
                        className="rounded-btn"
                        shape="circle"
                        onClick={() => handleClick1(productReleseasValue)}
                      >
                        {_enum[1]}
                        {/* JUST_IN */}
                      </Button>
                    ) : (
                      ""
                    )}
                    {/* productReleaseEnumValue */}
                    {/* {productReleseasValue && (
                      <Button className="rounded-btn" shape="circle" onClick={() => handleClick1(productReleseasValue)} >
                        {_enum[productReleseasValue]}
                      </Button>
                    )} */}
                  </div>

                  <Typography.Title level={3}>
                    {`${ProductData?.artists?.name}${ProductData?.artist2 != null
                      ? ` / ${ProductData?.artist2?.name}`
                      : ""
                      }${ProductData?.artist3 != null
                        ? ` / ${ProductData?.artist3?.name}`
                        : ""
                      }${ProductData?.artist4 != null
                        ? ` / ${ProductData?.artist4?.name}`
                        : ""
                      }${featuringName !== "" ? ` Featuring ${featuringName}` : ""
                      }`}
                  </Typography.Title>
                  <Typography.Title level={4} className="product_title">
                    {ProductData?.title}
                  </Typography.Title>
                  {/* label-desc-title */}
                  <a
                    className="lable-desc-anchor"
                    onClick={() =>
                      handleSaveLabelName(
                        ProductData?.secondary_labelname ??
                        ProductData?.labels?.name
                      )
                    }
                  >
                    {ProductData?.secondary_labelname ??
                      ProductData?.labels?.name}
                  </a>
                  {/* <Button className="label-desc-title" onClick={() => handleSaveLabelName(ProductData?.labels?.name)}>
                    {ProductData?.labels?.name}
                  </Button> */}
                  <div className="categories-listing">
                    <div className="categories-list">
                      <div className="categories-items">
                        Cat :&nbsp;
                        <span>
                          {" "}
                          {ProductData?.catNo || Localize.NotAvailable}
                        </span>
                      </div>
                      <div>
                        Barcode :&nbsp;
                        <span>
                          {" "}
                          {ProductData?.barcode || Localize.NotAvailable}
                        </span>
                      </div>
                    </div>
                    <div className="categories-list">
                      <div className="categories-items">
                        Format :&nbsp;
                        <span>
                          {" "}
                          {ProductData?.format || Localize.NotAvailable}
                        </span>
                      </div>
                      {/* <div>
                        STOCK LEVEL :&nbsp;
                        <span>
                          <StockLevel />
                        </span>
                      </div> */}
                      {/* need to undo these changes i.e. keeping two-items per row; FORMAT & STOCK LEVEL in one row and so on*/}
                      <div>
                        Genre :&nbsp;
                        <span>{genreList || Localize.NotAvailable}</span>
                      </div>
                    </div>

                    <div className="categories-list">
                      {
                        isDownload ? (<div className="categories-items">Downloading Assets…</div>) : (<div className="categories-items">
                          Download Assets
                          <a onClick={() => handleClick()}>
                            &nbsp;
                            <DownloadAssets />
                          </a>
                        </div>)
                      }
                      <div>
                        Spec :&nbsp;
                        <span>{specList || Localize.NotAvailable}</span>
                      </div>
                    </div>
                    <div className="categories-list">
                      <div>
                        Disc Colour :&nbsp;
                        <span>{ProductData?.discColour || "Black"}</span>
                      </div>
                    </div>
                    <div className="categories-list">
                      {
                        (isCart && !ProductData?.isForthcoming && isLogin) && (
                          <div className="counter-parent">
                            Quantity :&nbsp;
                            <span className="quantity">
                              <div className="counter">
                                {/* <QuantityCounter
                              minusHandler={minusHandler}
                              plusHandler={plusHandler}
                              count={count}
                              id={""}
                            /> */}
                                <input value={count} type="text" onChange={(e) => {
                                  const value = e.target.value;
                                  const numericValue = +value; // Convert the value to a number

                                  // Only set the count if the numeric value is not negative
                                  if (numericValue >= 0 || value === '') {
                                    setCount(numericValue);  // Allow empty input as well (e.g., user clears the input)
                                  }
                                }} className="quantity-input" />
                              </div>
                            </span>
                          </div>
                        )
                      }

                      {isLogin ? (
                        <div className="unit-price">
                          Unit Price :&nbsp;
                          <span>
                            {ProductData?.sellPrice
                              ? formatCurrency(ProductData?.sellPrice)
                              : Localize.NotAvailable}
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {
                    (isCart  && !ProductData?.isForthcoming && isLogin) && (
                      <div className="mob-btn">
                        <Button
                          className="full-btn add-to-cart-button"
                          data-testid="addToCart"
                          disabled={
                            ProductData?.sellPrice === null
                              ? true
                              : false
                          }
                          onClick={() => setHandleClick()}
                        >
                          {buttonText}
                          <div className="add-price">
                            {" "}
                            £{(ProductData?.sellPrice * count).toFixed(2)}
                            <AddToOrder />
                          </div>
                        </Button>
                      </div>
                    )
                  }
                  <Collapse
                    defaultActiveKey={["1", "2"]}
                    className="releases-collapse-desc-wrap"
                  >
                    <Panel header="Description" key="1">
                      {ProductData?.hype ? (
                        <p
                          dangerouslySetInnerHTML={{
                            __html: ProductData?.hype,
                          }}
                        ></p>
                      ) : (
                        Localize.NotAvailable
                      )}
                    </Panel>

                    {/* <Panel header="DJ FEEDBACK / PRESS SUPPORT" key="2">
                      {ProductData?.feedback || ProductData?.press ? (
                        <>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: ProductData?.feedback,
                            }}
                          ></div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: ProductData?.press,
                            }}
                          ></div>
                        </>
                      ) : (
                        Localize.NotAvailable
                      )}
                    </Panel> */}
                  </Collapse>

                  <div className="mobile-left-desc left-desc">
                    {productTracks?.length > 0 && (
                      <>
                        <Typography.Text className="tract-text">
                          Tracklist
                        </Typography.Text>
                        <Tabs defaultActiveKey={"0"} onChange={callback}>
                          {productTracks?.map((element: any, index: any) => {
                            return (
                              <TabPane tab={element?.plabel} key={index}>
                                {element?.tracks?.map(
                                  (elem: any, index1: any) => {
                                    return (
                                      <>
                                        <div className="track-list">
                                          <AudioPlayers
                                            track={musicUrl(
                                              elem?.productType?.name,
                                              elem?.catNo,
                                              elem?.soundClipFile
                                            )}
                                            index={index1}
                                            allIndex={allIndex}
                                            setAllIndex={setAllIndex}
                                          />
                                          <div className="audio-text">
                                            {alphabetPosition(index + 1)}
                                            {index1 + 1} -{" "}
                                            {elem?.webTitle || elem?.title}
                                            <br />
                                          </div>
                                        </div>
                                      </>
                                    );
                                  }
                                )}
                              </TabPane>
                            );
                          })}
                        </Tabs>
                      </>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          {Loading ? (
            <Loadingtext />
          ) : (
            <>
              {RelProductsData?.length > 0 ? (
                <>
                  <Typography.Title level={2} className="releases-heading">
                    <span className="dot"></span>More From{" "}
                    {ProductData?.secondary_labelname ??
                      ProductData?.labels?.name}{" "}
                  </Typography.Title>

                  <Content className="releases">
                    <div className="container">
                      <List
                        className="main-releases-listing"
                        dataSource={RelProductsData.filter(
                          (item) => item?.catNo !== proId
                        )}
                        locale={{ emptyText: <NoRecordFound /> }}
                        renderItem={(item: any) => (
                          <List.Item>
                            {/* fgfgf */}
                            <Releases
                              image={imageUrl(
                                item?.productType?.name,
                                item?.catNo
                              )}
                              title={item.title || Localize.TitleNotAvailable}
                              labelName={
                                item?.secondary_labelname ||
                                item?.labels?.name ||
                                Localize.LabelNotAvailable
                              }
                              desc={
                                item.shortDescription ||
                                Localize.DescriptionNotAvailable
                              }
                              forthComing={item.isForthcoming || false}
                              isRsdSpecial={item.isRsdSpecial || false}
                              productId={item.id}
                              artistName={
                                item?.artists?.name ||
                                Localize.ArtistNotAvailable
                              }
                              catNo={item?.catNo}
                              productType={item?.productType?.name}
                              title1="yes"
                            />
                            {/* <Link to={`/products/${item?.productType?.name}/${item?.catNo}`}>
                              <div>
                                <Image preview={false} src={imageUrl(
                                  item?.productType?.name,
                                  item?.catNo
                                )} onError={(e: any) => e.target.src = '/default_image.png'}
                                //  onError={"https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50"}
                                />
                                <Typography.Title level={3}>{item?.artists?.name ||
                                  Localize.ArtistNotAvailable}</Typography.Title>
                                <Typography.Title level={4}>{item.title || Localize.TitleNotAvailable}</Typography.Title>
                                <Typography.Title level={4}>{item?.catNo}</Typography.Title>
                                <Typography.Title level={4}>{item.labels.name || Localize.LabelNotAvailable}</Typography.Title>
                                {item.shortDescription ||
                                  Localize.DescriptionNotAvailable}
                              </div>
                            </Link> */}
                          </List.Item>
                        )}
                      />
                    </div>
                  </Content>
                </>
              ) : (
                " "
              )}
              <a
                className="rounded-btn service-bottom-btn"
                onClick={() =>
                  handleSaveLabelName(
                    ProductData?.secondary_labelname ??
                    ProductData?.labels?.name
                  )
                }
              >
                See all releases
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25.625"
                  height="17.623"
                  viewBox="0 0 25.625 17.623"
                >
                  <g
                    id="Group_280"
                    data-name="Group 280"
                    transform="translate(6855.444 -343.358) rotate(180)"
                  >
                    <path
                      id="Path_13"
                      data-name="Path 13"
                      d="M6838.983-343.712l-8.458-8.458,8.458-8.458"
                      transform="translate(0.001 0)"
                      fill="none"
                      stroke="#fff"
                      stroke-width="1"
                    ></path>
                    <line
                      id="Line_7"
                      data-name="Line 7"
                      x2="24.5"
                      transform="translate(6830.944 -352.426)"
                      fill="none"
                      stroke="#fff"
                      stroke-width="1"
                    ></line>
                  </g>
                </svg>
              </a>
              {/* <Link
                className="rounded-btn service-bottom-btn"
                to={"/releases" + `/?labelName=${ProductData?.labels?.name}`}
              >
                SEE ALL RELEASES FROM THE LABEL
              </Link> */}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ReleasesDesc;
